import React from 'react'
import Select from 'react-select'
import { isEqual } from 'lodash'
import DeleteConfirmation from '../ui/DeleteConfirmation'
import { sortOpts } from '../../utils/utils'

export default class LinkItem extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      data: props.link,
      delConf: false,
      errors: {},
      edit: false
    };
  }

  saveLink = e => {
    e.preventDefault();
    const { data } = this.state;
    if(isEqual(this.props.link, data)) {
      this.cancelEdit();
    }
    else {
      this.props.editLink(data, err => {
        if (err) {
          this.setState({errors: err});
          return;
        }
        this.setState({
          errors: {},
          edit:false
        });
      });
    }
  }

  deleteLink = e => {
    e.preventDefault();
    this.props.editLink({
      ...this.props.link,
      link_active: 0
    }, err => {
      if (err) {
        this.setState({errors: err});
        return;
      }
      this.setState({
        errors: {},
        edit:false
      });
    });
  }

  onclick = e => {
    e.preventDefault();
    this.setState({edit:true});
  }

  cancelEdit = () => {
    this.setState({edit:false});
  }

  openLink = e => {
    e.preventDefault();
    e.stopPropagation();
    window.open(this.props.link.link_url, '_blank');
  }

  updateInput = e => {
    this.setState({
      data:{
        ...this.state.data,
        [e.target.name]: e.target.value
      }
    });
  }

  updateFiletype = e => {
    this.setState({
      data: {
        ...this.state.data,
        link_filetype_id: e.value
      }
    });
  }

  toggleDelConf = () => {
    const delConf = !this.state.delConf;
    this.setState({delConf:delConf});
  }

  render() {

    const { edit, data, errors } = this.state;
    const { link, filetypes } = this.props;

    const filetypesOpt = [];
    for (let key in filetypes){
      if(filetypes.hasOwnProperty(key) && (filetypes[key].filetype_active === 1
        || filetypes[key].filetype_id === data.link_filetype_id)) {
        filetypesOpt.push({value:filetypes[key].filetype_id,label:filetypes[key].filetype_desc});
      }
    }
    filetypesOpt.sort(sortOpts);

    const delConf = this.state.delConf ?
      <DeleteConfirmation
        onDelete={this.deleteLink}
        onCancel={this.toggleDelConf}
      />
      :
      '';
    if (edit){
      return (
        <tr>
          <td>
            {delConf}
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={data.link_desc}
                placeholder="Описание"
                name="link_desc"
                onChange={this.updateInput}
              />
            </div>
            <button  type="button" className="btn btn-success btn-sm"
              onClick={this.saveLink} title="Сохранить">
              <span className="glyphicon glyphicon-save"></span>
            </button>{" "}
            <button type="button" className="btn btn-default btn-sm"
              onClick={this.cancelEdit} title="Отменить">
              <span className="glyphicon glyphicon-remove"></span>
            </button>{" "}
            <button type="button" className="btn btn-danger btn-sm"
              onClick={this.toggleDelConf} title="Удалить">
              <span className="glyphicon glyphicon-trash"></span>
            </button>
            {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          </td>
          <td>
            <Select
              clearable={false}
              options={filetypesOpt}
              value={data.link_filetype_id}
              onChange={this.updateFiletype}
              placeholder="Тип файла"
            />
          </td>
          <td>
            <div className="form-group">
              <textarea type="text"
                rows="2"
                className="form-control"
                value={data.link_url}
                placeholder="Адрес"
                name="link_url"
                onChange={this.updateInput}
              />
            </div>
          </td>
        </tr>
      );
    }
    else{
      const filtypeDesc = filetypes[link.link_filetype_id] ?
        filetypes[link.link_filetype_id].filetype_desc : '';
      const filetypeColor = filetypes[link.link_filetype_id] ?
        filetypes[link.link_filetype_id].filetype_color : 'transparent';
      return (
        <tr className="show-hover-container" onClick={this.onclick}>
          <td>
            <button type="button" className="btn btn-info btn-xs show-hover"
              onClick={this.openLink}>
              Открыть
            </button>{" "+link.link_desc}
            {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          </td>
          <td>
            <span
              className="glyphicon glyphicon-tag"
              style={{color: filetypeColor}}
            />{" "}
            {filtypeDesc}
          </td>
          <td>{link.link_url.slice(0,50) + "..."}</td>
        </tr>
      )
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/order/LinkItem.js